// extracted by mini-css-extract-plugin
module.exports = {"containerHome":"boxContainer_containerHome__ui_kJ","containerFullScreen":"boxContainer_containerFullScreen__10Kxl"};